import {
  documentsGet,
  documentsPost,
  orgDocumentLinksGet,
  putDocument,
  removeDocument,
  removeDocuments,
} from '../../../data/repositories/doucuments/DocumentsRepository'

export async function getDocumentLinks() {
  return await orgDocumentLinksGet()
}

export async function getDocuments(query: string) {
  return await documentsGet(query)
}

export async function createDocuments(files: any[]) {
  return await documentsPost(files)
}

export async function deleteDocument(id: string) {
  return await removeDocument(id)
}

export async function deleteDocuments(ids: string[]) {
  return await removeDocuments(ids)
}

export async function updatedDocument(id: string, filename: string) {
  return await putDocument(id, filename)
}
